import styled, { css } from 'styled-components';

interface LogoContainerProps {
  size: 'small' | 'medium' | 'large';
}

interface LogoTextProps {
  primary?: boolean;
}

export const LogoContainer = styled.div<LogoContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ size }) => {
    switch (size) {
      case 'small':
        return css`
          width: 80px;
          height: 80px;
        `;
      case 'large':
        return css`
          height: 50px;
        `;
      default:
        return css`
          height: 50px;
        `;
    }
  }}
`;

export const LogoImage = styled.img`
  min-width: 50px;
  max-height: 50px;
  height: 100%;
  width: 90%;
  object-fit: contain;
`;

export const LogoText = styled.span<LogoTextProps>`
  font-weight: bold;

  ${({ primary, theme }) =>
    primary &&
    css`
      color: ${theme.primaryColor};
      margin-right: 0px;
    `}

  ${({ primary, theme }) =>
    !primary &&
    css`
      color: ${theme.textColor};
    `}
`;
